function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 8,
  fill: "#EEF5FF"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M26.13 20L27.39 18.74C27.83 18.3 28.39 18.06 29 18V17L23 11H13C11.89 11 11 11.89 11 13V27C11 27.5304 11.2107 28.0391 11.5858 28.4142C11.9609 28.7893 12.4696 29 13 29H19V27.13L19.13 27H13V13H20V20H26.13ZM22 12.5L27.5 18H22V12.5ZM27.13 21.83L29.17 23.87L23.04 30H21V27.96L27.13 21.83ZM30.85 22.19L29.87 23.17L27.83 21.13L28.81 20.15C29 19.95 29.33 19.95 29.53 20.15L30.85 21.47C31.05 21.67 31.05 22 30.85 22.19Z",
  fill: "#365DE6"
});
const SvgColoredWritePost = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColoredWritePost, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/colored-write-post.2cabfe96.svg";
export { ForwardRef as ReactComponent };